// Libraries
import {Col, Dropdown, MenuProps} from 'antd';
import {DownloadOutlined, DownOutlined, UploadOutlined} from "@ant-design/icons";
import { useTranslation } from 'react-i18next';

// Components
import ButtonComponent from "../subComponents/ButtonComponent";

// Store
import {useAppDispatch} from '../../store/store';
import {getCatalogTemplate, getExcludeCatalogTemplate} from '../../store/redux/actions/catalogActions';
import {getProductStoreTemplate} from '../../store/redux/actions/productStoreActions';
import { SystemParamsType } from '../../types/CatalogTypes';


type FileManagementType = {
  systemParams: SystemParamsType ;
  onToggleUploadCatalogModal: () => void;
  onToggleUploadCatalogToExcludeModal: () => void;
  onToggleUploadProductStoreModal: () => void;
};
const FileManagement = (props: FileManagementType) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const dropdownItems: MenuProps['items'] = [
    {
      key: '1',
      label: <span className={'text-blue-dkt-400'}
                   onClick={() => dispatch(getProductStoreTemplate())}>
        {t('inventoryTemplate')}
      </span>,
      icon: <DownloadOutlined className={'text-blue-dkt-400'} />,
    },
    {
      key: '2',
      label: <span className={'text-orange-dkt-400'}
                   onClick={props.onToggleUploadProductStoreModal}>
        {t('loadInventory')}
      </span>,
      icon: <UploadOutlined className={'text-orange-dkt-400'} />,
    },
    {
      type: 'divider',
    },
    {
      key: '3',
      label: <span className={'text-blue-dkt-400'}
                   onClick={() => dispatch(getCatalogTemplate())}>
        {t('catalogTemplate')}
      </span>,
      icon: <DownloadOutlined className={'text-blue-dkt-400'} />,
    },
    {
      key: '4',
      label: <span className={'text-orange-dkt-400'}
                   onClick={props.onToggleUploadCatalogModal}>
        {t('loadCatalog')}
      </span>,
      icon: <UploadOutlined className={'text-orange-dkt-400'} />,
    },
  ];

  if (props.systemParams?.excludeCatalog) {
    dropdownItems.push(
      {
        type: 'divider',
      },
      {
        key: '5',
        label: <span className={'text-blue-dkt-400'}
                    onClick={() => dispatch(getExcludeCatalogTemplate())}>
          {t('catalogTemplateToExclude')}
        </span>,
        icon: <DownloadOutlined className={'text-blue-dkt-400'} />,
      },
      {
        key: '6',
        label: <span className={'text-orange-dkt-400'}
                    onClick={props.onToggleUploadCatalogToExcludeModal}>
          {t('loadCatalogToExclude')}
        </span>,
        icon: <DownloadOutlined className={'text-orange-dkt-400'} />,
      },
    );
  }

  return (
    <Col className={'mt-4 sm:mt-0 sm:text-right'}>
      <Dropdown menu={{ items: dropdownItems }}
                arrow={true}
                trigger={['click']}>
        <ButtonComponent text={t('actions')}
                         icon={<DownOutlined />}
                         className={'text-blue-dkt-400 bg-white hover:bg-blue-dkt-100 border-blue-dkt-400 ' +
                           'focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-dkt-300 '} />
      </Dropdown>
    </Col>
  );
}

export default FileManagement;